// Client-side photo resize (v1 behavior carried): any picked image — camera JPEG,
// gallery PNG, iOS HEIC — is re-encoded to a ~1280px JPEG before upload, which also
// guarantees it passes the server's magic-byte gate.
export async function resizeImage(file: File, maxDim = 1280, quality = 0.8): Promise<Blob> {
  const url = URL.createObjectURL(file);
  try {
    const img = await new Promise<HTMLImageElement>((resolve, reject) => {
      const el = new Image();
      el.onload = () => resolve(el);
      el.onerror = () => reject(new Error('unreadable image'));
      el.src = url;
    });
    const scale = Math.min(1, maxDim / Math.max(img.width, img.height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(img.width * scale));
    canvas.height = Math.max(1, Math.round(img.height * scale));
    canvas.getContext('2d')!.drawImage(img, 0, 0, canvas.width, canvas.height);
    const blob = await new Promise<Blob | null>((resolve) =>
      canvas.toBlob(resolve, 'image/jpeg', quality),
    );
    if (!blob) throw new Error('encode failed');
    return blob;
  } finally {
    URL.revokeObjectURL(url);
  }
}
